import { centroid } from "@thi.ng/geom-poly-utils";
import { comp, mapcat, partition, push, transduce, wrapSides, } from "@thi.ng/transducers";
import { mixN } from "@thi.ng/vectors";
export const edgeSplit = (points) => {
    const c = centroid(points);
    return transduce(comp(partition(2, 1), mapcat(([a, b]) => {
        const m = mixN([], a, b, 0.5);
        return [
            [a, m, c],
            [m, b, c],
        ];
    })), push(), wrapSides(points, 0, 1));
};
